import { get } from 'services/request';
import { ICompoundEdit } from './CompoundModel';
import { BaseModel, IModelOptions } from './BaseModel';

export default class CompoundCardModel extends BaseModel {
  constructor(options: IModelOptions & { compoundId: number }) {
    super(options);
    this.loadItemEdit(options.compoundId);
  }

  async loadItemData(id: number) {
    const compoundData = await get<ICompoundEdit>(`compounds/${id}`);
    return { cardData: compoundData };
  }
}